// extracted by mini-css-extract-plugin
module.exports = {"layout":"ImageMapIcon_layout__2e1o7","iconPlus":"ImageMapIcon_iconPlus__1xp8S","iconMinus":"ImageMapIcon_iconMinus__2Xh-Q"};